import { addDays, format, parseISO } from "date-fns";
import type { CommunicationListParams } from "@/types/communications";

function toGmailDate(isoDate: string): string {
  return format(parseISO(isoDate), "yyyy/MM/dd");
}

/**
 * Build a Gmail API `q` search string from list params.
 * @see https://support.google.com/mail/answer/7190
 */
export function buildGmailSearchQuery(params: CommunicationListParams): string | undefined {
  const parts: string[] = [];

  const from = params.from?.trim();
  if (from) {
    parts.push(`from:${from.includes(" ") ? `"${from}"` : from}`);
  }

  const dateFrom = params.dateFrom?.trim();
  const dateTo = params.dateTo?.trim();

  if (dateFrom && (!dateTo || dateFrom === dateTo)) {
    parts.push(`on:${toGmailDate(dateFrom)}`);
  } else if (dateFrom || dateTo) {
    if (dateFrom) {
      parts.push(`after:${toGmailDate(dateFrom)}`);
    }
    if (dateTo) {
      // Gmail `before:` is exclusive — add one day for inclusive end date
      parts.push(`before:${toGmailDate(format(addDays(parseISO(dateTo), 1), "yyyy-MM-dd"))}`);
    }
  }

  const query = params.query?.trim();
  if (query) {
    parts.push(query);
  }

  return parts.length > 0 ? parts.join(" ") : undefined;
}
